import customaxios from ".";
import store from "../store";
import axios from "axios";

const baseURL = process.env.REACT_APP_AI_BASE_URL;

// export const requestCall = (data: unknown) => {
//   return axios({
//     method: "POST",
//     // baseURL: baseURL,
//     url: `${baseURL}/vapi-call-user`,
//     data,
//   });
// };

export const requestCall = (data: any) => {
  return customaxios({
    method: "POST",
    url: `/ai-voice-agent/request-call`,
    data: {
      phone_number: data.phone_number,
      arguments: data.arguments || {},
    },
  });
};
export const requestMessage = (data: unknown) => {
  return axios({
    method: "POST",
    // baseURL: baseURL,
    url: `${baseURL}/vapi-chat`,
    data,
  });
};